import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { Picture } from '../ui/Picture';
import { Button, RoundButton } from '../ui/Button';
import { CarouselTrack, CarouselArrows, CarouselDots } from '../ui/Carousel';
import { useCarousel } from '../../hooks/useCarousel';
import { howItWorks } from '../../data/landing';
import styles from './HowItWorks.module.css';

export function HowItWorks() {
  const { trackRef, index, count, atStart, atEnd, next, prev, goTo } = useCarousel();

  return (
    <Section id="how-it-works">
      <SectionHeader
        eyebrow={howItWorks.eyebrow}
        title={howItWorks.title}
        subtitle={howItWorks.subtitle}
        align="start"
        actions={
          <CarouselArrows prev={prev} next={next} atStart={atStart} atEnd={atEnd} label="steps" />
        }
      />

      {/* 500px cards with a 40px gutter, per the comp; the track bleeds right so
          the third card peeks past the container edge. */}
      <CarouselTrack
        trackRef={trackRef}
        bleed
        itemWidth="clamp(300px, 38vw, 500px)"
        gap="40px"
        aria-label="How NimblePark works, step by step"
      >
        {howItWorks.steps.map((step) => (
          <article key={step.n} className={`${styles.card} zoom-target`}>
            <Picture
              name={step.image}
              alt=""
              sizes="(max-width: 767px) 88vw, 500px"
              zoom
              fill
              className={styles.photo}
            />

            <div className={styles.caption}>
              <div>
                <p className={styles.kicker}>
                  <span className={styles.n}>{step.n}</span>
                  {step.kicker}
                </p>
                <h3 className={`${styles.title} u-h3`}>{step.title}</h3>
              </div>
              <RoundButton icon="arrow-up-right" variant="dark" size={48} label={`More about ${step.kicker}`} to={howItWorks.cta.to} />
            </div>
          </article>
        ))}
      </CarouselTrack>

      <CarouselDots count={count} index={index} goTo={goTo} label="step" />

      <div className={styles.cta}>
        <Button to={howItWorks.cta.to} icon="arrow-right-circle">
          {howItWorks.cta.label}
        </Button>
      </div>
    </Section>
  );
}
